import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import styled from '@emotion/styled'

const PageWrapperEl = styled.div`
  background: white;
  min-height: calc(100vh - 72px);

  main {
    display: flex;
    flex-flow: column;
    align-items: stretch;
  }
`

const PageWrapper = ({ inContextFlow, children }) => {
  window.scrollTo(0, 0)

  if (inContextFlow) {
    return <Fragment>{children}</Fragment>
  }

  return <PageWrapperEl className="ppdg-wrapper">{children}</PageWrapperEl>
}

PageWrapper.propTypes = {
  inContextFlow: PropTypes.bool,
  children: PropTypes.array,
}

const PageWrapperWithRouter = withRouter(PageWrapper)
export { PageWrapperWithRouter as PageWrapper }
